import {
  normalize,
  tldNamehash
} from "./chunk-SUONEYMI.mjs";
import {
  __async,
  __forAwait
} from "./chunk-Z5PC3CM3.mjs";

// src/tlds/web3name/index.ts
import { createPublicClient as createPublicClient4, http as http4, namehash as namehash2 } from "viem";
import { normalize as normalize2 } from "viem/ens";

// src/constants/tld.ts
var exampleTld = {
  tld: "woaf8",
  identifier: BigInt("2615353277007099930642231241208939993573210331169845997366433981082573"),
  registry: "0x4a343ed86c8591eE644e115258ba5763e1Fa00B8",
  chainId: BigInt(97),
  defaultRpc: "https://data-seed-prebsc-1-s1.binance.org:8545"
};

// src/utils/common.ts
import { createPublicClient, http } from "viem";
import { mainnet, goerli, sepolia } from "viem/chains";
function createCustomClient(tldInfo, rpcUrl) {
  const client = createPublicClient({
    chain: {
      id: Number(tldInfo.chainId),
      rpcUrls: {
        default: { http: [rpcUrl || tldInfo.defaultRpc] },
        public: { http: [rpcUrl || tldInfo.defaultRpc] }
      },
      name: "",
      network: "",
      nativeCurrency: {
        decimals: 18,
        name: "",
        symbol: ""
      }
    },
    transport: http()
  });
  return client;
}
var v2Tlds = /* @__PURE__ */ new Set(["bnb", "arb", "eth"]);
function isV2Tld(tld) {
  return v2Tlds.has(tld);
}
function isEthChain(chainId) {
  const ethChains = /* @__PURE__ */ new Set([mainnet.id, goerli.id, sepolia.id]);
  return ethChains.has(chainId);
}
function getChainFromId(chainId) {
  switch (chainId) {
    case 1:
      return mainnet;
    case 5:
      return goerli;
    case 11155111:
      return sepolia;
    default:
      return mainnet;
  }
}
function getBaseContractFromChainId(chainId) {
  switch (chainId) {
    case 1:
    case 11155111:
      return "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85";
    case 56:
      return "0xE3b1D32e43Ce8d658368e2CBFF95D57Ef39Be8a6";
    case 97:
      return "0x888A2BA9787381000Cd93CA4bd23bB113f03C5Af";
    case 42161:
      return "0x5d482d501b369f5ba034dec5c5fb7a50d2d6ca20";
    default:
      return "0x57f1887a8bf19b14fc0df6fd9b2acc9af147ea85";
  }
}

// src/utils/contract.ts
import {
  createPublicClient as createPublicClient2,
  getContract,
  getFunctionSelector,
  hexToBigInt,
  hexToNumber,
  http as http2,
  keccak256
} from "viem";
import { bscTestnet, mainnet as mainnet2 } from "viem/chains";

// src/abi/Resolver.ts
var ResolverAbi = [
  {
    inputs: [
      { internalType: "contract SidRegistry", name: "_sidRegistry", type: "address" },
      { internalType: "address", name: "_trustedController", type: "address" },
      { internalType: "uint256", name: "chainType", type: "uint256" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: true, internalType: "uint256", name: "contentType", type: "uint256" }
    ],
    name: "ABIChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "address", name: "a", type: "address" }
    ],
    name: "AddrChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "uint256", name: "coinType", type: "uint256" },
      { indexed: false, internalType: "bytes", name: "newAddress", type: "bytes" }
    ],
    name: "AddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: true, internalType: "address", name: "operator", type: "address" },
      { indexed: false, internalType: "bool", name: "approved", type: "bool" }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "bytes", name: "hash", type: "bytes" }
    ],
    name: "ContenthashChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: true, internalType: "bytes4", name: "interfaceID", type: "bytes4" },
      { indexed: false, internalType: "address", name: "implementer", type: "address" }
    ],
    name: "InterfaceChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "string", name: "name", type: "string" }
    ],
    name: "NameChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "previousOwner", type: "address" },
      { indexed: true, internalType: "address", name: "newOwner", type: "address" }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "bytes32", name: "x", type: "bytes32" },
      { indexed: false, internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    name: "PubkeyChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: true, internalType: "string", name: "indexedKey", type: "string" },
      { indexed: false, internalType: "string", name: "key", type: "string" },
      { indexed: false, internalType: "string", name: "value", type: "string" }
    ],
    name: "TextChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "uint256", name: "identifier", type: "uint256" },
      { indexed: false, internalType: "string", name: "name", type: "string" }
    ],
    name: "TldNameChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "bytes32", name: "node", type: "bytes32" },
      { indexed: false, internalType: "uint64", name: "newVersion", type: "uint64" }
    ],
    name: "VersionChanged",
    type: "event"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "contentTypes", type: "uint256" }
    ],
    name: "ABI",
    outputs: [
      { internalType: "uint256", name: "", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "addr",
    outputs: [{ internalType: "address payable", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "coinType", type: "uint256" }
    ],
    name: "addr",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "clearRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "contenthash",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "defaultCoinType",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes4", name: "interfaceID", type: "bytes4" }
    ],
    name: "interfaceImplementer",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "account", type: "address" },
      { internalType: "address", name: "operator", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes[]", name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ internalType: "bytes[]", name: "results", type: "bytes[]" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "node", type: "bytes32" }],
    name: "pubkey",
    outputs: [
      { internalType: "bytes32", name: "x", type: "bytes32" },
      { internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes32", name: "", type: "bytes32" }],
    name: "recordVersions",
    outputs: [{ internalType: "uint64", name: "", type: "uint64" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "controller", type: "address" }],
    name: "removeTrustedController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  { inputs: [], name: "renounceOwnership", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "contentType", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "setABI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "coinType", type: "uint256" },
      { internalType: "bytes", name: "a", type: "bytes" }
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "address", name: "a", type: "address" }
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "operator", type: "address" },
      { internalType: "bool", name: "approved", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes", name: "hash", type: "bytes" }
    ],
    name: "setContenthash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes4", name: "interfaceID", type: "bytes4" },
      { internalType: "address", name: "implementer", type: "address" }
    ],
    name: "setInterface",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "newName", type: "string" }
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newController", type: "address" }],
    name: "setNewTrustedController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "bytes32", name: "x", type: "bytes32" },
      { internalType: "bytes32", name: "y", type: "bytes32" }
    ],
    name: "setPubkey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" }
    ],
    name: "setText",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "identifier", type: "uint256" },
      { internalType: "string", name: "newName", type: "string" }
    ],
    name: "setTldName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceID", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "string", name: "key", type: "string" }
    ],
    name: "text",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "node", type: "bytes32" },
      { internalType: "uint256", name: "identifier", type: "uint256" }
    ],
    name: "tldName",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes32", name: "", type: "bytes32" },
      { internalType: "uint256", name: "", type: "uint256" }
    ],
    name: "tldNames",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/ReverseResolver.ts
var ReverseResolverAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "contentType",
        type: "uint256"
      }
    ],
    name: "ABIChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address"
      }
    ],
    name: "AddrChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coinType",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newAddress",
        type: "bytes"
      }
    ],
    name: "AddressChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "ContentChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "hash",
        type: "bytes"
      }
    ],
    name: "ContenthashChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string"
      }
    ],
    name: "NameChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "x",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "y",
        type: "bytes32"
      }
    ],
    name: "PubkeyChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "string",
        name: "indexedKey",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "TextChanged",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "contentTypes",
        type: "uint256"
      }
    ],
    name: "ABI",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256"
      }
    ],
    name: "addr",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "contenthash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "dnsrr",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "pubkey",
    outputs: [
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      }
    ],
    name: "text",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4"
      }
    ],
    name: "interfaceImplementer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "contentType",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "setABI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "a",
        type: "bytes"
      }
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "addr",
        type: "address"
      }
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes"
      }
    ],
    name: "setContenthash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "setDnsrr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "_name",
        type: "string"
      }
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32"
      }
    ],
    name: "setPubkey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "string",
        name: "key",
        type: "string"
      },
      {
        internalType: "string",
        name: "value",
        type: "string"
      }
    ],
    name: "setText",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4"
      },
      {
        internalType: "address",
        name: "implementer",
        type: "address"
      }
    ],
    name: "setInterface",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]"
      }
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "content",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "multihash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32"
      }
    ],
    name: "setContent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes"
      }
    ],
    name: "setMultihash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/abi/SANN.ts
var SANNContractAbi = [
  {
    inputs: [{ internalType: "uint256", name: "identifier", type: "uint256" }],
    name: "tldBase",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/SIDRegistry.ts
var SIDRegistryAbi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "label",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "NewOwner",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "NewResolver",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "NewTTL",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "setRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "setSubnodeRecord",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "bytes32",
        name: "label",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "setSubnodeOwner",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "resolver",
        type: "address"
      }
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      },
      {
        internalType: "uint64",
        name: "ttl",
        type: "uint64"
      }
    ],
    name: "setTTL",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "resolver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "ttl",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32"
      }
    ],
    name: "recordExists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/TldBase.ts
var TldBaseContractAbi = [
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/VerifiedTldHub.ts
var VerifiedTldHubAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "previousOwner", type: "address" },
      { indexed: true, internalType: "address", name: "newOwner", type: "address" }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    inputs: [{ internalType: "uint256", name: "chainId", type: "uint256" }],
    name: "getChainInfo",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "chainId", type: "uint256" },
          { internalType: "string", name: "defaultRpc", type: "string" },
          { internalType: "address", name: "registry", type: "address" },
          { internalType: "address", name: "sann", type: "address" }
        ],
        internalType: "struct VerifiedTldHub.chainInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "chainId", type: "uint256" }],
    name: "getChainTlds",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string[]", name: "tlds", type: "string[]" }],
    name: "getTldInfo",
    outputs: [
      {
        components: [
          { internalType: "string", name: "tld", type: "string" },
          { internalType: "uint256", name: "identifier", type: "uint256" },
          { internalType: "uint256", name: "chainId", type: "uint256" },
          { internalType: "string", name: "defaultRpc", type: "string" },
          { internalType: "address", name: "registry", type: "address" },
          { internalType: "address", name: "sann", type: "address" }
        ],
        internalType: "struct VerifiedTldHub.completeTldInfo[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getTlds",
    outputs: [{ internalType: "string[]", name: "", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "string", name: "tldName", type: "string" }
    ],
    name: "removeTldInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  { inputs: [], name: "renounceOwnership", outputs: [], stateMutability: "nonpayable", type: "function" },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "string", name: "defaultRpc", type: "string" },
      { internalType: "address", name: "registry", type: "address" },
      { internalType: "address", name: "sann", type: "address" }
    ],
    name: "updateChainInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "chainId", type: "uint256" },
      { internalType: "string", name: "defaultRpc", type: "string" }
    ],
    name: "updateDefaultRpc",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "tldName", type: "string" },
      { internalType: "uint256", name: "identifier", type: "uint256" },
      { internalType: "uint256", name: "chainId", type: "uint256" }
    ],
    name: "updateTldInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/constants/contracts.ts
var CONTRACTS = {
  verifiedTldHub: "0x754D6827A57334143eD5fB58C5b1A4aAe4396ba5",
  verifiedTldHubTest: "0x123c784946a9b649FB1268D589E41bc7BF658725"
};

// src/utils/contract.ts
var ContractReader = class {
  constructor(isDev) {
    this.isDev = isDev;
  }
  /** Get verified TLD hub contract */
  getVerifiedTldHubContract() {
    const ethClient = createPublicClient2({
      chain: this.isDev ? bscTestnet : mainnet2,
      transport: http2(this.isDev ? void 0 : "https://rpc.ankr.com/eth")
    });
    const hubContract = getContract({
      address: this.isDev ? CONTRACTS.verifiedTldHubTest : CONTRACTS.verifiedTldHub,
      abi: VerifiedTldHubAbi,
      publicClient: ethClient
    });
    return hubContract;
  }
  getTldInfo(tldList) {
    return __async(this, null, function* () {
      const hubContract = this.getVerifiedTldHubContract();
      const tldInfoList = yield hubContract.read.getTldInfo([tldList]);
      return tldInfoList.filter((e) => !!e.tld);
    });
  }
  /**
   * Get resolver contract by TLD
   *
   * @export
   * @param {string} domain
   * @param {TldInfo} tldInfo
   * @param {string} [rpcUrl]
   * @return {*}
   */
  getResolverContractByTld(namehash3, tldInfo, rpcUrl) {
    return __async(this, null, function* () {
      const client = createCustomClient(tldInfo, rpcUrl);
      const registryContract = getContract({
        address: tldInfo.registry,
        abi: SIDRegistryAbi,
        publicClient: client
      });
      const resolverAddr = yield registryContract.read.resolver([namehash3]);
      if (!hexToNumber(resolverAddr)) {
        throw "resolver address is null";
      }
      const resolverContract = getContract({
        address: resolverAddr,
        abi: ResolverAbi,
        publicClient: client
      });
      return resolverContract;
    });
  }
  /** Get reverse resolver contract (V2 only) */
  getReverseResolverContract(reverseNamehash, tldInfo, rpcUrl) {
    return __async(this, null, function* () {
      if (!tldInfo.defaultRpc)
        return void 0;
      const client = createCustomClient(tldInfo, rpcUrl);
      const registryContract = getContract({
        address: tldInfo.registry,
        abi: SIDRegistryAbi,
        publicClient: client
      });
      const resolverAddr = yield registryContract.read.resolver([reverseNamehash]);
      const resolverContract = getContract({
        address: resolverAddr != null ? resolverAddr : "",
        abi: ReverseResolverAbi,
        publicClient: client
      });
      return resolverContract;
    });
  }
  getTldMetadata(domain, tldInfo, rpcUrl) {
    return __async(this, null, function* () {
      const tokenId = hexToBigInt(keccak256(Buffer.from(domain.split(".")[0])));
      const client = createCustomClient(tldInfo, rpcUrl);
      const sannContract = getContract({
        address: tldInfo.sann,
        abi: SANNContractAbi,
        publicClient: client
      });
      const tldBaseContractAddr = tldInfo.identifier === BigInt(0) ? getBaseContractFromChainId(Number(tldInfo.chainId)) : yield sannContract.read.tldBase([BigInt(`${tldInfo.identifier}`)]);
      if (tldInfo.chainId === BigInt(mainnet2.id)) {
        return `https://metadata.ens.domains/mainnet/${tldBaseContractAddr}/${tokenId}`;
      }
      const tldBaseContract = getContract({ address: tldBaseContractAddr, abi: TldBaseContractAbi, publicClient: client });
      const metadata = yield tldBaseContract.read.tokenURI([tokenId]);
      return metadata;
    });
  }
  containsTldNameFunction(resolverAddr, tldInfo, rpcUrl) {
    return __async(this, null, function* () {
      var _a;
      const client = createCustomClient(tldInfo, rpcUrl);
      const bytecode = yield client.getBytecode({ address: resolverAddr });
      const selector = getFunctionSelector("tldName(bytes32, uint256)");
      return (_a = bytecode == null ? void 0 : bytecode.includes(selector.slice(2))) != null ? _a : false;
    });
  }
};

// src/constants/whitelist.ts
var whitelist_default = [
  "cz.bnb",
  "id.bnb",
  "sm.bnb",
  "yg.bnb",
  "cz.eth.bnb",
  "id.eth.bnb",
  "sm.eth.bnb",
  "yg.eth.bnb",
  "go.arb"
];

// src/utils/validate.ts
import { validate as ensValidate } from "@ensdomains/ens-validation";
import { toArray } from "lodash";

// src/utils/labels.ts
function isEncodedLabelhash(hash) {
  return hash.startsWith("[") && hash.endsWith("]") && hash.length === 66;
}

// src/utils/validate.ts
function validateName(name) {
  if (!name) {
    throw new Error("Invalid name");
  }
  const labelArr = name.split(".");
  let domain = name;
  let suffix = "";
  if (labelArr.length > 1) {
    domain = labelArr.slice(0, labelArr.length - 1).join(".");
    suffix = labelArr[labelArr.length - 1];
  }
  if (labelArr.length === 3 && suffix.toLowerCase() === "bnb" && labelArr[1].toLowerCase() === "eth") {
    domain = labelArr[0];
  }
  const hasEmptyLabels = labelArr.filter((e) => e.length < 1).length > 0;
  if (hasEmptyLabels)
    throw new Error("Domain cannot have empty labels");
  if (!validateLabelLength(domain) && !whitelist_default.includes(name.toLowerCase())) {
    throw new Error("Invalid name");
  }
  if (!validateDomains(domain))
    throw new Error("Invalid name");
  const normalizedArray = labelArr.map((label) => {
    return isEncodedLabelhash(label) ? label : normalize(label);
  });
  try {
    return normalizedArray.join(".");
  } catch (e) {
    throw e;
  }
}
function validateLabelLength(name) {
  if (!name) {
    return false;
  }
  const len = toArray(name).length;
  if (len < 3 || len > 512) {
    return false;
  }
  let normalizedValue;
  try {
    normalizedValue = normalize(name);
  } catch (e) {
    normalizedValue = name;
  }
  if (normalizedValue.length < 3 || normalizedValue.length > 512) {
    return false;
  }
  return true;
}
function validateDomains(value) {
  const nospecial = /^[^*|\\":<>[\]{}`\\\\()';@&$]+$/u;
  const blackList = /[\u0000-\u002c\u002e-\u002f\u003a-\u005e\u0060\u007b-\u007f\u200b\u200c\u200d\ufeff]/g;
  return nospecial.test(value) && !blackList.test(value) && ensValidate(value);
}

// src/tlds/UD/index.ts
import { createPublicClient as createPublicClient3, getContract as getContract2, http as http3, namehash } from "viem";
import { polygon } from "viem/chains";

// src/abi/UD/ProxyReader.ts
var proxyReaderAbi = [
  {
    inputs: [
      { internalType: "contract IUNSRegistry", name: "unsRegistry", type: "address" },
      { internalType: "contract ICNSRegistry", name: "cnsRegistry", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "string", name: "label", type: "string" }
    ],
    name: "childIdOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "exists",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "get",
    outputs: [{ internalType: "string", name: "value", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "keyHash", type: "uint256" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getByHash",
    outputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getData",
    outputs: [
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getDataByHash",
    outputs: [
      { internalType: "address", name: "resolver", type: "address" },
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }
    ],
    name: "getDataByHashForMany",
    outputs: [
      { internalType: "address[]", name: "resolvers", type: "address[]" },
      { internalType: "address[]", name: "owners", type: "address[]" },
      { internalType: "string[][]", name: "keys", type: "string[][]" },
      { internalType: "string[][]", name: "values", type: "string[][]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }
    ],
    name: "getDataForMany",
    outputs: [
      { internalType: "address[]", name: "resolvers", type: "address[]" },
      { internalType: "address[]", name: "owners", type: "address[]" },
      { internalType: "string[][]", name: "values", type: "string[][]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getMany",
    outputs: [{ internalType: "string[]", name: "values", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getManyByHash",
    outputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "isApprovedOrOwner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes[]", name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ internalType: "bytes[]", name: "results", type: "bytes[]" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }],
    name: "ownerOfForMany",
    outputs: [{ internalType: "address[]", name: "owners", type: "address[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "registryOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "resolverOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  }
];

// src/abi/UD/UNSRegistry.ts
var unsRegistryAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: "address", name: "previousAdmin", type: "address" },
      { indexed: false, internalType: "address", name: "newAdmin", type: "address" }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: true, internalType: "address", name: "approved", type: "address" },
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "owner", type: "address" },
      { indexed: true, internalType: "address", name: "operator", type: "address" },
      { indexed: false, internalType: "bool", name: "approved", type: "bool" }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "uint8", name: "version", type: "uint8" }],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" },
      { indexed: true, internalType: "string", name: "keyIndex", type: "string" },
      { indexed: false, internalType: "string", name: "key", type: "string" }
    ],
    name: "NewKey",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" },
      { indexed: false, internalType: "string", name: "uri", type: "string" }
    ],
    name: "NewURI",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: false, internalType: "string", name: "prefix", type: "string" }],
    name: "NewURIPrefix",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: "address", name: "addr", type: "address" }],
    name: "RemoveReverse",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ResetRecords",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" },
      { indexed: true, internalType: "string", name: "keyIndex", type: "string" },
      { indexed: true, internalType: "string", name: "valueIndex", type: "string" },
      { indexed: false, internalType: "string", name: "key", type: "string" },
      { indexed: false, internalType: "string", name: "value", type: "string" }
    ],
    name: "Set",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "addr", type: "address" },
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "SetReverse",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      { indexed: true, internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: "address", name: "implementation", type: "address" }],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [],
    name: "BATCH_LIMIT",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "key", type: "string" }],
    name: "addKey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "addProxyReader",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "bytes", name: "depositData", type: "bytes" }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "depositToPolygon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "uint256", name: "nonce", type: "uint256" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
          { internalType: "bytes", name: "data", type: "bytes" }
        ],
        internalType: "struct IForwarder.ForwardRequest",
        name: "req",
        type: "tuple"
      },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "execute",
    outputs: [{ internalType: "bytes", name: "", type: "bytes" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "exists",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "get",
    outputs: [{ internalType: "string", name: "value", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "keyHash", type: "uint256" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getByHash",
    outputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "keyHash", type: "uint256" }],
    name: "getKey",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256[]", name: "hashes", type: "uint256[]" }],
    name: "getKeys",
    outputs: [{ internalType: "string[]", name: "values", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getMany",
    outputs: [{ internalType: "string[]", name: "values", type: "string[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "getManyByHash",
    outputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "mintingManager", type: "address" },
      { internalType: "address", name: "cnsRegistry", type: "address" },
      { internalType: "address", name: "rootChainManager", type: "address" },
      { internalType: "address", name: "childChainManager", type: "address" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "operator", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "spender", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "isApprovedOrOwner",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "forwarder", type: "address" }],
    name: "isTrustedForwarder",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "", type: "bytes" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "string", name: "uri", type: "string" }
    ],
    name: "mintTLD",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "string[]", name: "labels", type: "string[]" },
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
      { internalType: "bool", name: "withReverse", type: "bool" }
    ],
    name: "mintWithRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes[]", name: "data", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ internalType: "bytes[]", name: "results", type: "bytes[]" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string[]", name: "labels", type: "string[]" }],
    name: "namehash",
    outputs: [{ internalType: "uint256", name: "hash", type: "uint256" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "nonceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "", type: "address" },
      { internalType: "address", name: "from", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "onERC721Received",
    outputs: [{ internalType: "bytes4", name: "", type: "bytes4" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "reconfigure",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "removeReverse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "reset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "resolverOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseNameOf",
    outputs: [{ internalType: "string", name: "reverseUri", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "reverseOf",
    outputs: [{ internalType: "uint256", name: "reverse", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "root",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "data", type: "bytes" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string", name: "key", type: "string" },
      { internalType: "string", name: "value", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "set",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "operator", type: "address" },
      { internalType: "bool", name: "approved", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256", name: "keyHash", type: "uint256" },
      { internalType: "string", name: "value", type: "string" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "setByHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "setMany",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "uint256[]", name: "keyHashes", type: "uint256[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "setManyByHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "string[]", name: "labels", type: "string[]" }],
    name: "setReverse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "prefix", type: "string" }],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "string[]", name: "labels", type: "string[]" },
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" },
      { internalType: "bool", name: "withReverse", type: "bool" }
    ],
    name: "unlockWithRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "uint256[]", name: "tokenIds", type: "uint256[]" }],
    name: "upgradeAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "from", type: "address" },
          { internalType: "uint256", name: "nonce", type: "uint256" },
          { internalType: "uint256", name: "tokenId", type: "uint256" },
          { internalType: "bytes", name: "data", type: "bytes" }
        ],
        internalType: "struct IForwarder.ForwardRequest",
        name: "req",
        type: "tuple"
      },
      { internalType: "bytes", name: "signature", type: "bytes" }
    ],
    name: "verify",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { internalType: "bytes", name: "inputData", type: "bytes" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "string[]", name: "keys", type: "string[]" },
      { internalType: "string[]", name: "values", type: "string[]" }
    ],
    name: "withdrawFromPolygon",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

// src/tlds/UD/index.ts
var UDResolver = class {
  constructor() {
    this.proxyReaderAddress = "0x423F2531bd5d3C3D4EF7C318c2D1d9BEDE67c680";
    this.unsRegistryAddress = "0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f";
  }
  /**
   * Resolve address from name
   * @param domain
   * @returns
   */
  getAddress(domain) {
    return __async(this, null, function* () {
      const client = createPublicClient3({
        chain: polygon,
        transport: http3()
      });
      const proxyReaderContract = getContract2({
        address: this.proxyReaderAddress,
        abi: proxyReaderAbi,
        publicClient: client
      });
      const keys = ["crypto.ETH.address"];
      const res = yield proxyReaderContract.read.getMany([keys, BigInt(namehash(domain))]);
      return res.at(0) || null;
    });
  }
  /**
   * Resolve name from address
   * @param address
   * @returns
   */
  getName(address) {
    return __async(this, null, function* () {
      const client = createPublicClient3({
        chain: polygon,
        transport: http3()
      });
      const registryContract = getContract2({
        address: this.unsRegistryAddress,
        abi: unsRegistryAbi,
        publicClient: client
      });
      const res = yield registryContract.read.reverseNameOf([address]);
      if (!res.endsWith(".crypto")) {
        return null;
      }
      return res;
    });
  }
};

// src/tlds/lens/index.ts
var baseUrl = "https://api.lens.dev/";
var LensProtocol = class {
  static getDomainName(address) {
    return __async(this, null, function* () {
      const gql = `
      query Profile($ethereumAddress: EthereumAddress!) {
        defaultProfile(request: { ethereumAddress: $ethereumAddress }) {
          id
          handle
        }
      }
    `;
      const res = yield fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: gql,
          variables: {
            ethereumAddress: address
          }
        })
      }).then((res2) => res2.json());
      return res.data.defaultProfile.handle;
    });
  }
  static getAddress(domain) {
    return __async(this, null, function* () {
      const gql = `
      query Profile ($handle: Handle!) {
        profile(request: { handle: $handle }) {
          id
          ownedBy
        }
      }
    `;
      const res = yield fetch(baseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: gql,
          variables: {
            handle: domain
          }
        })
      }).then((res2) => res2.json());
      return res.data.profile.ownedBy;
    });
  }
};

// src/tlds/web3name/index.ts
var Web3Name = class {
  constructor({ isDev = false }) {
    this.contractReader = new ContractReader(isDev);
  }
  /**
   * Get domain name from address.
   * If queryChainIdList is specified, it will return domain name from that chain.
   * If queryTldList is specified, it will return domain name from that TLDs with the order.
   * If neither is specified, it will return domain name from all TLDs.
   * It's not recommended to use queryChainIdList and queryTldList together.
   *
   * @param {GetDomainNameProps} { address, queryChainIdList, queryTldList }
   * @return {*}  {(Promise<string | null>)}
   * @memberof Web3Name
   */
  getDomainName(_0) {
    return __async(this, arguments, function* ({ address, queryChainIdList, queryTldList, rpcUrl }) {
      var _a, _b;
      if ((queryChainIdList == null ? void 0 : queryChainIdList.length) && (queryTldList == null ? void 0 : queryTldList.length)) {
        console.warn("queryChainIdList and queryTldList cannot be used together, queryTldList will be ignored");
      }
      try {
        const reverseNode = `${normalize2(address).slice(2)}.addr.reverse`;
        const reverseNamehash = namehash2(reverseNode);
        const hubContract = this.contractReader.getVerifiedTldHubContract();
        const chainTlds = [];
        try {
          for (var iter = __forAwait(queryChainIdList != null ? queryChainIdList : []), more, temp, error; more = !(temp = yield iter.next()).done; more = false) {
            const chainId = temp.value;
            const tlds2 = yield hubContract.read.getChainTlds([BigInt(chainId)]);
            if (isEthChain(chainId)) {
              const ethTld = tlds2.filter((e) => e !== "eth" /* ENS */).at(0);
              if (ethTld)
                chainTlds.push(ethTld);
              chainTlds.push("eth" /* ENS */);
            } else {
              const tldName = tlds2.at(0);
              if (tldName)
                chainTlds.push(tldName);
            }
          }
        } catch (temp) {
          error = [temp];
        } finally {
          try {
            more && (temp = iter.return) && (yield temp.call(iter));
          } finally {
            if (error)
              throw error[0];
          }
        }
        const tlds = queryTldList != null ? queryTldList : [];
        if (tlds.length === 0) {
          const allTlds = yield hubContract.read.getTlds();
          tlds.push(...allTlds);
        }
        const reqTlds = (queryChainIdList == null ? void 0 : queryChainIdList.length) ? chainTlds : tlds;
        const tldInfoList = yield this.contractReader.getTldInfo(reqTlds);
        const resList = [];
        try {
          for (var iter2 = __forAwait(tldInfoList), more2, temp2, error2; more2 = !(temp2 = yield iter2.next()).done; more2 = false) {
            const tld = temp2.value;
            if (!tld.tld)
              continue;
            let name = "";
            try {
              if (tld.tld === "eth" /* ENS */) {
                const contract = yield this.contractReader.getReverseResolverContract(reverseNamehash, tld, rpcUrl);
                name = (_a = yield contract == null ? void 0 : contract.read.name([reverseNamehash])) != null ? _a : "";
              } else {
                const contract = yield this.contractReader.getResolverContractByTld(reverseNamehash, tld, rpcUrl);
                if (queryTldList == null ? void 0 : queryTldList.length) {
                  if (isV2Tld(tld.tld)) {
                    const containsTldNameFunction = yield this.contractReader.containsTldNameFunction(
                      contract.address,
                      tld,
                      rpcUrl
                    );
                    if (!containsTldNameFunction)
                      throw "TLD name is not supported for this TLD";
                  }
                  name = yield contract.read.tldName([reverseNamehash, tld.identifier]);
                } else {
                  name = yield contract.read.name([reverseNamehash]);
                }
              }
            } catch (error3) {
              continue;
            }
            if (name) {
              const reverseAddress = yield this.getAddress(name, { rpcUrl });
              if ((reverseAddress == null ? void 0 : reverseAddress.toLowerCase()) === address.toLowerCase()) {
                resList.push(name);
                break;
              }
            }
          }
        } catch (temp2) {
          error2 = [temp2];
        } finally {
          try {
            more2 && (temp2 = iter2.return) && (yield temp2.call(iter2));
          } finally {
            if (error2)
              throw error2[0];
          }
        }
        if (queryTldList == null ? void 0 : queryTldList.includes("lens" /* LENS */)) {
          const lensName = yield LensProtocol.getDomainName(address);
          if (lensName)
            resList.push(lensName);
        } else if (queryTldList == null ? void 0 : queryTldList.includes("crypto" /* CRYPTO */)) {
          const UD = new UDResolver();
          const udName = yield UD.getName(address);
          if (udName)
            resList.push(udName);
        }
        return (_b = resList.at(0)) != null ? _b : null;
      } catch (e) {
        console.log(`Error getting name for reverse record of ${address}`, e);
        return null;
      }
    });
  }
  /**
   * Get address from name. If coinType is specified, it will return ENSIP-9 address for that coinType.
   *
   * @param {string} name
   * @param {{ coinType?: number; rpcUrl?: string }} { coinType, rpcUrl }
   * @return {*}  {(Promise<string | null>)}
   * @memberof Web3Name
   */
  getAddress(_0) {
    return __async(this, arguments, function* (name, { coinType, rpcUrl } = {}) {
      var _a;
      const tld = (_a = name.split(".").pop()) == null ? void 0 : _a.toLowerCase();
      if (!tld) {
        return null;
      }
      const normalizedDomain = "lens" /* LENS */ === tld ? name : normalize2(name);
      if (tld !== "eth" /* ENS */ && tld !== "lens" /* LENS */ && tld !== "crypto" /* CRYPTO */) {
        validateName(normalizedDomain);
      }
      try {
        if (tld === "eth" /* ENS */) {
          const tldInfoList2 = yield this.contractReader.getTldInfo([tld]);
          const publicClient = createPublicClient4({
            chain: getChainFromId(Number(tldInfoList2[0].chainId)),
            transport: http4()
          });
          return yield publicClient.getEnsAddress({
            name: normalizedDomain
          });
        }
        if (tld === "lens" /* LENS */) {
          return yield LensProtocol.getAddress(name);
        }
        if (tld === "crypto" /* CRYPTO */) {
          const UD = new UDResolver();
          return yield UD.getAddress(name);
        }
        const tldInfoList = yield this.contractReader.getTldInfo([tld]);
        const tldInfo = tldInfoList.at(0);
        if (!tldInfo) {
          throw "TLD not found";
        }
        const namehash3 = tldNamehash(normalizedDomain, isV2Tld(tld) ? void 0 : tldInfo.identifier);
        const resolverContract = yield this.contractReader.getResolverContractByTld(namehash3, tldInfo, rpcUrl);
        const res = coinType !== void 0 ? yield resolverContract.read.addr([namehash3, BigInt(coinType)]) : yield resolverContract.read.addr([namehash3]);
        return res;
      } catch (error) {
        console.error(`Error getting address for ${name}`, error);
        return null;
      }
    });
  }
  /**
   * Get available domain list from address.
   *
   * @param {GetDomainNameProps} { address, queryChainIdList, queryTldList }
   * @return {*}  {Promise<string[]>}
   * @memberof Web3Name
   */
  getDomainNames(_0) {
    return __async(this, arguments, function* ({ address, queryChainIdList, queryTldList, rpcUrl }) {
      var _a;
      if ((queryChainIdList == null ? void 0 : queryChainIdList.length) && (queryTldList == null ? void 0 : queryTldList.length)) {
        console.warn("queryChainIdList and queryTldList cannot be used together, queryTldList will be ignored");
      }
      const resList = /* @__PURE__ */ new Set([]);
      try {
        const reverseNode = `${address.toLowerCase().slice(2)}.addr.reverse`;
        const reverseNamehash = namehash2(reverseNode);
        const hubContract = this.contractReader.getVerifiedTldHubContract();
        const chainTlds = [];
        for (const chainId of queryChainIdList != null ? queryChainIdList : []) {
          const tlds2 = yield hubContract.read.getChainTlds([BigInt(chainId)]);
          if (isEthChain(chainId)) {
            const ethTld = tlds2.filter((e) => e !== "eth" /* ENS */).at(0);
            if (ethTld)
              chainTlds.push(ethTld);
            chainTlds.push("eth" /* ENS */);
          } else {
            const tldName = tlds2.at(0);
            if (tldName)
              chainTlds.push(tldName);
          }
        }
        const tlds = queryTldList != null ? queryTldList : [];
        if (tlds.length === 0) {
          const allTlds = yield hubContract.read.getTlds();
          tlds.push(...allTlds);
        }
        const reqTlds = (queryChainIdList == null ? void 0 : queryChainIdList.length) ? chainTlds : tlds;
        const tldInfoList = yield this.contractReader.getTldInfo(reqTlds);
        for (const tld of tldInfoList) {
          if (!tld.tld)
            continue;
          let name = "";
          try {
            if (tld.tld === "eth" /* ENS */) {
              const contract = yield this.contractReader.getReverseResolverContract(reverseNamehash, tld, rpcUrl);
              name = (_a = yield contract == null ? void 0 : contract.read.name([reverseNamehash])) != null ? _a : "";
            } else {
              const contract = yield this.contractReader.getResolverContractByTld(reverseNamehash, tld);
              if (queryTldList == null ? void 0 : queryTldList.length) {
                if (isV2Tld(tld.tld)) {
                  const containsTldNameFunction = yield this.contractReader.containsTldNameFunction(contract.address, tld);
                  if (!containsTldNameFunction)
                    throw "TLD name is not supported for this TLD";
                }
                name = yield contract.read.tldName([reverseNamehash, tld.identifier]);
              } else {
                name = yield contract.read.name([reverseNamehash]);
              }
            }
          } catch (error) {
            continue;
          }
          if (name) {
            const reverseAddress = yield this.getAddress(name, { rpcUrl });
            if (reverseAddress === address) {
              resList.add(name);
            }
          }
        }
        if (queryTldList == null ? void 0 : queryTldList.includes("lens" /* LENS */)) {
          const lensName = yield LensProtocol.getDomainName(address);
          if (lensName)
            resList.add(lensName);
        } else if (queryTldList == null ? void 0 : queryTldList.includes("crypto" /* CRYPTO */)) {
          const UD = new UDResolver();
          const name = yield UD.getName(address);
          name && resList.add(name);
        }
        return Array.from(resList);
      } catch (e) {
        console.log(`Error getting name for reverse record of ${address}`, e);
        return [];
      }
    });
  }
  /**
   * Get domain record from name and key.
   *
   * @param {{ name: string; key: string; rpcUrl?: string }} { name, key, rpcUrl }
   * @return {*}
   * @memberof Web3Name
   */
  getDomainRecord(_0) {
    return __async(this, arguments, function* ({ name, key, rpcUrl }) {
      var _a;
      const tld = (_a = name.split(".").pop()) == null ? void 0 : _a.toLowerCase();
      if (!tld) {
        return null;
      }
      try {
        const normalizedDomain = "lens" /* LENS */ === tld ? name : normalize2(name);
        const tldInfoList = yield this.contractReader.getTldInfo([tld]);
        const tldInfo = tldInfoList[0];
        if (!tldInfo) {
          throw "TLD not found";
        }
        const namehash3 = tldNamehash(normalizedDomain, isV2Tld(tld) ? void 0 : tldInfo.identifier);
        const resolverContract = yield this.contractReader.getResolverContractByTld(namehash3, tldInfo, rpcUrl);
        const record = yield resolverContract.read.text([namehash3, key]);
        return record;
      } catch (error) {
        console.error(`Error getting address for ${name}`, error);
        return null;
      }
    });
  }
  /**
   * Get domain metadata from name.
   *
   * @param {{ name: string; rpcUrl?: string }} { name, rpcUrl }
   * @return {*}
   * @memberof Web3Name
   */
  getMetadata(_0) {
    return __async(this, arguments, function* ({ name, rpcUrl }) {
      var _a, _b;
      const tld = (_a = name.split(".").pop()) == null ? void 0 : _a.toLowerCase();
      if (!tld) {
        return null;
      }
      try {
        const tldInfo = yield this.contractReader.getTldInfo([tld]);
        if (!tldInfo || !((_b = tldInfo.at(0)) == null ? void 0 : _b.sann)) {
          return null;
        }
        const metadata = yield this.contractReader.getTldMetadata(name, tldInfo[0], rpcUrl);
        const res = yield fetch(metadata).then((res2) => res2.json());
        return res;
      } catch (error) {
        console.error(`Error getting metadata for ${name}`, error);
      }
    });
  }
  /**
   * Get domain avatar from name.
   *
   * @param {{ name: string; key: string; rpcUrl?: string }} { name, rpcUrl }
   * @return {*}
   * @memberof Web3Name
   */
  getDomainAvatar(_0) {
    return __async(this, arguments, function* ({ name, rpcUrl }) {
      const metadata = yield this.getMetadata({ name, rpcUrl });
      return metadata == null ? void 0 : metadata.image;
    });
  }
};

// src/index.ts
function createWeb3Name({ isDev = false } = {}) {
  return new Web3Name({ isDev });
}
export {
  createWeb3Name
};
